import { db } from '@services/offline/db';
import type { Product, ProductSummary, TankOption } from '../types/stationAssets';

const toProductSummary = (product: Product): ProductSummary => ({
  id: product.id,
  name: product.name,
  code: product.code
});

export const stationAssetCache = {
  async saveProducts(products: Product[]) {
    if (products.length === 0) {
      return;
    }

    await db.products.bulkPut(products);
  },
  async saveTanks(tanks: TankOption[]) {
    if (tanks.length === 0) {
      return;
    }

    await db.tanks.bulkPut(tanks.map((tank) => ({ ...tank, id: String(tank.id) })));
  },
  async getAllowedProductsForTank(tankId: string | number) {
    const tank = await db.tanks.get(String(tankId));

    if (!tank) {
      return [];
    }

    if (tank.product_detail) {
      return [tank.product_detail];
    }

    if (tank.current_product_detail) {
      return [tank.current_product_detail];
    }

    const configuredProductId = tank.product ?? tank.current_product;

    if (configuredProductId) {
      const product = await db.products.get(String(configuredProductId));

      if (product) {
        return [toProductSummary(product)];
      }
    }

    if (tank.allowed_products_detail && tank.allowed_products_detail.length > 0) {
      return tank.allowed_products_detail;
    }

    if (!tank.allowed_products || tank.allowed_products.length === 0) {
      return [];
    }

    const products = await db.products.bulkGet(tank.allowed_products.map(String));

    return products.filter(Boolean).map((product) => toProductSummary(product as Product));
  }
};
